module.exports = __webpack_public_path__ + "static/media/allImpact_10y_y-1.6cebab82.csv";